module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/promos/2025/blackfridaysale/1138x90/domainsearch.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/promos/2025/blackfridaysale/1138x90/domainsearch.png
// module id = D7P6
// module chunks = 0